<template>
  <a-table
    :dataSource="dataSource"
    :columns="searchParams.terminalId === 1 ? columns : appColumns"
    :scroll="{ x: 1000 }"
    :pagination="false"
    @resizeColumn="handleResizeColumn"
    class="mb40"
  >
    <template v-slot:bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'status'">
        <span>{{ record.status - 0 === 1 ? '使用中' : '未使用' }}</span>
      </template>
      <template v-if="column.dataIndex === 'subChannel'">
        <span>{{ record.subChannel - 0 === 1 ? 'PC端' : 'M端' }}</span>
      </template>
      <template v-if="column.dataIndex === 'colType'">
        <span>{{ record.colType - 0 ? '自动' : '手动' }}</span>
      </template>
      <template v-if="column.dataIndex === 'peopleGoodsFlag'">
        <a-popconfirm
          :title="`是否${record.peopleGoodsFlag - 0 ? '禁用' : '启用'}?`"
          ok-text="确定"
          cancel-text="取消"
          @confirm="
            () =>
              col_activeCol_post({
                ...record,
                peopleGoodsFlag: record.peopleGoodsFlag - 0 ? 0 : 1
              })
          "
        >
          <a-switch
            checked-children="启用"
            un-checked-children="禁用"
            :checked="record.peopleGoodsFlag - 0 ? true : false"
          />
        </a-popconfirm>
      </template>
      <template v-if="column.dataIndex === 'promotionFlag'">
        <div>
          {{
            record.promotionFlag - 0 === 1
              ? '是'
              : text.promotionFlag - 0 === 0
              ? '否'
              : ''
          }}
        </div>
      </template>
      <template v-if="column.dataIndex === 'deal'">
        <div class="df" style="justify-content: center;">
          <a-button
            type="link"
            @click="
              jumpPage('NavigationDetail', { ...record, ...searchParams })
            "
            >编辑</a-button
          >
          <a-popconfirm
            title="确定复制该导航?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="() => copyRecord(record.id)"
          >
            <a-button type="link">复制</a-button>
          </a-popconfirm>

          <a-popconfirm
            title="确定删除该导航?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="() => deleteRow({ ...record })"
          >
            <a-button type="link" v-if="record.status - 0 !== 1">删除</a-button>
          </a-popconfirm>

          <a-button
            type="link"
            style="color: #cccccc;"
            v-if="record.status - 0 === 1"
            >删除</a-button
          >
        </div>
      </template>
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
export default {
  setup() {
    const columns = ref([
      {
        title: '导航名称',
        dataIndex: 'navName',
        key: 'navName',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '适用子终端',
        width: 150,
        resizable: true,
        align: 'center',
        dataIndex: 'subChannel'
      },
      {
        title: '导航类型',
        dataIndex: 'navType',
        key: 'navType',
        resizable: true,
        align: 'center',
        width: 100
      },
      {
        title: '状态',
        dataIndex: 'status',
        resizable: true,
        align: 'center',
        width: 100
      },
      {
        title: '创建人',
        dataIndex: 'createUser',
        key: 'createUser',
        resizable: true,
        align: 'center',
        width: 100
      },
      {
        title: '更新人',
        dataIndex: 'updateUser',
        key: 'updateUser',
        resizable: true,
        align: 'center',
        width: 120
      },
      {
        title: '更新时间',
        dataIndex: 'lastUpdateTime',
        key: 'lastUpdateTime',
        align: 'center',
        width: 120
      },
      {
        title: '操作',
        dataIndex: 'deal',
        key: 'deal',
        fixed: 'right',
        align: 'center',
        width: 130
      }
    ])
    const appColumns = ref([
      {
        title: '导航名称',
        dataIndex: 'navName',
        key: 'navName',
        resizable: true,
        width: 100,
        align: 'center'
      },

      {
        title: '状态',
        dataIndex: 'status',
        resizable: true,
        align: 'center',
        width: 100
      },
      {
        title: '创建人',
        dataIndex: 'createUser',
        key: 'createUser',
        resizable: true,
        align: 'center',
        width: 100
      },
      {
        title: '更新人',
        dataIndex: 'updateUser',
        key: 'updateUser',
        resizable: true,
        align: 'center',
        width: 120
      },
      {
        title: '更新时间',
        dataIndex: 'lastUpdateTime',
        key: 'lastUpdateTime',
        align: 'center',
        width: 120
      },
      {
        title: '操作',
        dataIndex: 'deal',
        key: 'deal',
        fixed: 'right',
        align: 'center',
        width: 100
      }
    ])
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      columns,
      appColumns,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
